import { CommentFilters } from "common/constants";

/**
 * Joins names into a readable list, e.g. ["A"] -> "A", ["A","B"] -> "A and B",
 * ["A","B","C"] -> "A, B and C"
 */
export function formatNameList(names) {
    if (names.length === 0) {
        return "";
    }
    if (names.length === 1) {
        return names[0];
    }
    return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}

export function getLikeTooltipTitle(likerNames) {
    return likerNames.length > 0 ? `Liked by ${formatNameList(likerNames)}` : "Like";
}

/**
 * Returns true if the comment html has no meaningful content. Browsers leave a
 * stray <br> in an emptied contenteditable, so a visually empty field is not
 * literally "". Mention (font) nodes keep their inner text, so they count as content.
 */
export function isCommentTextEmpty(html) {
    if (!html) {
        return true;
    }

    const withoutTags = html
        .replace(/<br\s*\/?>/gi, "")
        .replace(/<[^>]*>/g, "");

    return withoutTags.replace(/&nbsp;|\u00A0|\u202F/g, "").trim().length === 0;
}

/**
 * Split and filter comments for the pane's This Slide / All Slides / Resolved views.
 * Resolved threads are hidden from the first two filters.
 */
export function getCommentsPaneLists({ comments, byViewer, commentFilter, currentSlideId }) {
    const sortedComments = [...comments]
        .filter(c => (c.byViewer ?? false) === byViewer)
        .sort((a, b) => b.createdAt - a.createdAt);

    const slideComments = sortedComments.filter(c => c.slideId === currentSlideId && !c.resolved);
    const allComments = sortedComments.filter(c => !c.resolved);
    const resolvedComments = sortedComments.filter(c => !!c.resolved);

    let displayedComments = slideComments;
    if (commentFilter === CommentFilters.Resolved) {
        displayedComments = resolvedComments;
    } else if (commentFilter === CommentFilters.AllSlides) {
        displayedComments = allComments;
    }

    return { displayedComments, slideComments, allComments, resolvedComments };
}
